import { useTranslation } from 'react-i18next';
import { KoobAvatar, KoobInputSelect } from '@koob/ui';
import { RoleEnum } from '@koob/enums';
import TosMaximumTimeBeforeBooking from 'components/TosMaximumTimeBeforeBooking/TosMaximumTimeBeforeBooking';
import { useApp } from 'hooks';
import { formatCurrencyLabel } from 'utils';

function Setting({ label, children }) {
  return (
    <div className="flex flex-col gap-1 py-3 sm:flex-row sm:items-center sm:gap-6">
      <dt className="w-44 shrink-0 text-sm text-k-p">{label}</dt>
      <dd className="m-0 min-w-0">{children}</dd>
    </div>
  );
}

// The DMC organization whose connections the page lists (Koob admins pick
// it) and the settings every connection follows: default currency and how
// long before check-in TOs may book.
export default function DistributionOrganizationCard({
  organization,
  organizations,
  selectedOrganization,
  onOrganizationChange,
  isAllowedToManage,
}) {
  const { currentUserRole } = useApp();
  const { t } = useTranslation('toConnectionRequest');

  return (
    <section className="rounded-2xl border border-solid border-k-gray bg-white">
      <div className="flex flex-wrap items-center gap-3 border-b border-gray-200 px-5 py-4">
        <KoobAvatar
          src={organization?.avatarUrl}
          name={organization?.name}
          size={12}
          rounded="full"
        />
        <div className="min-w-0">
          <div className="text-xs font-medium uppercase tracking-wide text-k-p">
            {t('organization:distribution.title')}
          </div>
          {currentUserRole === RoleEnum.KOOB_ADMIN ? (
            <div className="mt-1 w-80 max-w-full">
              <KoobInputSelect
                searchable
                size="sm"
                options={
                  organizations?.length ? organizations : [selectedOrganization]
                }
                value={selectedOrganization?.value}
                onValueChange={(value) =>
                  onOrganizationChange(
                    organizations.find((o) => o.value === value),
                  )
                }
                placeholder={t('searchOrganization')}
              />
            </div>
          ) : (
            <div className="truncate text-base font-semibold text-k-h">
              {organization?.name}
            </div>
          )}
        </div>
      </div>

      <dl className="m-0 divide-y divide-gray-100 px-5">
        {selectedOrganization?.currency && (
          <Setting label={t('organization:distribution.currencyLabel')}>
            <span className="text-sm text-k-h">
              {formatCurrencyLabel(selectedOrganization.currency)}
            </span>
          </Setting>
        )}
        <Setting label={t('organization:distribution.cutoffLabel')}>
          <TosMaximumTimeBeforeBooking
            isAllowedToManage={isAllowedToManage}
            organizationId={Number(selectedOrganization?.value)}
          />
        </Setting>
      </dl>
    </section>
  );
}
